// creates history object to be used with BrowserRouter
// can be imported anywhere (including sagas) to force page change w/ history.push

import { createBrowserHistory } from 'history';

export default createBrowserHistory();
